export { default } from "./Svg";
export type { SvgProps } from "./Svg";
